import autosize from "autosize";

/**
 * Textarea Component
 *
 * @constructor
 */

export default function()
{
    autosize(document.querySelectorAll('textarea'));
}
